const normalizeValues = (value) => {
  if (Array.isArray(value)) return value
  return value === null || value === undefined ? [] : [value]
}

export default class TableQueryState {
  constructor(source = "") {
    const params = source instanceof URLSearchParams ? source : new URLSearchParams(source)
    this.entries = Array.from(
      new Map(Array.from(params.entries()).map(([key, value]) => [`${key}\u0000${value}`, [key, value]])).values()
    ).sort(
      ([leftKey, leftValue], [rightKey, rightValue]) =>
        leftKey.localeCompare(rightKey) || leftValue.localeCompare(rightValue)
    )
  }

  patch(changes, { resetPage = true } = {}) {
    const params = this.toSearchParams()

    Object.entries(changes).forEach(([key, value]) => {
      params.delete(key)
      normalizeValues(value).forEach((item) => {
        const normalized = String(item).trim()
        if (normalized !== "") params.append(key, normalized)
      })
    })

    if (resetPage) params.delete("page")
    return new TableQueryState(params)
  }

  toSearchParams() {
    return new URLSearchParams(this.entries)
  }

  toUrl(baseUrl) {
    const query = this.toSearchParams().toString()
    return query ? `${baseUrl}?${query}` : baseUrl
  }

  fingerprint({ exclude = ["page", "sort", "direction"] } = {}) {
    const params = this.toSearchParams()
    exclude.forEach((key) => params.delete(key))
    return new TableQueryState(params).toSearchParams().toString()
  }
}
